module.exports = __webpack_public_path__ + "./images/bluemap.b11397.svg";